import { render } from "./beforeAfterFour.vue?vue&type=template&id=23816560"
import script from "./beforeAfterFour.vue?vue&type=script&lang=js"
export * from "./beforeAfterFour.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__